import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

import StyledCart from '../Cart/styles';

const StyledFooter = styled.div`
  padding: ${themeGet('scale.scaleUp03')} 0;
  position: fixed;
  transition: bottom 150ms linear;
  left: 0;
  right: 0;
  color: ${themeGet('color.colorGrayBlue100')};
  background-color: ${themeGet('color.colorWhite')};
  border-top: ${themeGet('border.borderSmall')} solid
    ${themeGet('color.colorGrayBlue30')};
  z-index: ${themeGet('zIndex.zIndex02')};

  @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
    padding: ${themeGet('scale.scaleUp03')} 0;
    background-color: ${themeGet('color.colorBlueLightest')};
    border: 0;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    > div {
      flex: 1 1 auto;
    }

    > div:nth-of-type(2) {
      text-align: right;
    }

    @supports (display: grid) {
      display: grid;
      grid-template-columns: auto max-content;
      grid-column-gap: 30px;
      align-items: center;

      > div {
        flex: 0;
      }

      > div:nth-of-type(2) {
        text-align: inherit;
      }
    }
  }

  ${StyledCart} {
    @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
      grid-template-columns: 1fr;

      .cart-items,
      small {
        display: none;
      }

      .total {
        justify-self: start;
        text-align: left;
      }

      .total span {
        display: block;
        font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: ${themeGet('fontWeight.fontWeightMedium')};
        color: ${themeGet('color.colorGrayBlue60')};
      }
    }
  }
`;

export default StyledFooter;
